import './faq-section.sass';
import { useRef, useEffect, useState } from 'react';
import { Accordion, Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa6';

function FaqSection() {
  return (
    <Container fluid className="faqs-container">
      <FaqContainer />
    </Container>
  );
}

function FaqContainer() {
  return (
    <Row>
      <Col sm={4} className="faqs-class">
        <h1 className="h1-faqs">FAQs</h1>
      </Col>
      <Col sm={6}>
        <Faqs />
      </Col>
    </Row>
  );
}

function Faqs() {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState<string | null>(null);
  const headerRefs = useRef<(HTMLDivElement | null)[]>([]);

  const faqData = [
    {
      title: t('faq.general.title'),
      questions: [
        {
          question: t('faq.general.questions.0.question'),
          answer: t('faq.general.questions.0.answer'),
        },
        {
          question: t('faq.general.questions.1.question'),
          answer: t('faq.general.questions.1.answer'),
        },
        {
          question: t('faq.general.questions.2.question'),
          answer: t('faq.general.questions.2.answer'),
        },
      ],
    },
    {
      title: t('faq.booking.title'),
      questions: [
        {
          question: t('faq.booking.questions.0.question'),
          answer: t('faq.booking.questions.0.answer'),
        },
        {
          question: t('faq.booking.questions.1.question'),
          answer: t('faq.booking.questions.1.answer'),
        },
        {
          question: t('faq.booking.questions.2.question'),
          answer: t('faq.booking.questions.2.answer'),
        },
      ],
    },
    {
      title: t('faq.pricing.title'),
      questions: [
        {
          question: t('faq.pricing.questions.0.question'),
          answer: t('faq.pricing.questions.0.answer'),
        },
        {
          question: t('faq.pricing.questions.1.question'),
          answer: t('faq.pricing.questions.1.answer'),
        },
        {
          question: t('faq.pricing.questions.2.question'),
          answer: t('faq.pricing.questions.2.answer'),
        },
      ],
    },
    {
      title: t('faq.support.title'),
      questions: [
        {
          question: t('faq.support.questions.0.question'),
          answer: t('faq.support.questions.0.answer'),
        },
        {
          question: t('faq.support.questions.1.question'),
          answer: t('faq.support.questions.1.answer'),
        },
        {
          question: t('faq.support.questions.2.question'),
          answer: t('faq.support.questions.2.answer'),
        },
      ],
    },
  ];

  useEffect(() => {
    if (activeKey !== null) {
      const index = parseInt(activeKey);
      const targetElement = headerRefs.current[index];
  
      if (targetElement) {
        setTimeout(() => {
          // Apply the scroll with offset after checking that the element exists
          window.scrollTo({
            top: targetElement.offsetTop - 100, // Apply the offset here
            behavior: 'smooth',
          });
        }, 350);
      }
    }
  }, [activeKey]);

  return (
    <Accordion
      activeKey={activeKey}
      onSelect={(key) => setActiveKey(key as string | null)}
      flush
    >
      {faqData.map((faq, index) => (
        <Accordion.Item eventKey={String(index)} key={index}>
          <div
            ref={(el) => {
              headerRefs.current[index] = el;
            }}
          >
            <Accordion.Header>{faq.title}</Accordion.Header>
          </div>
          <Accordion.Body>
            <div>
              {faq.questions.map((faq, subIndex) => (
                <div className="mb-4" key={subIndex}>
                  <div className="faq-question">
                    <FaCheck className="faq-icon" />
                    <h5 className="faq-text">{faq.question}</h5>
                  </div>
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

export { FaqSection };
